import { authService } from "@/services/AuthService";

const EATZY_TOKEN_EXPIRES_KEY = "eatzyTokenExpires";

/**
 * Proactively refreshes the Eatzy user token if it is within 60 seconds of
 * expiry, then returns the current token value.
 *
 * Safe to call from any async context — AuthService guards concurrent calls.
 */
export async function ensureFreshEatzyToken(): Promise<string | null> {
  const expires = Number(localStorage.getItem(EATZY_TOKEN_EXPIRES_KEY) || 0);
  const nowSec = Math.floor(Date.now() / 1000);

  if (expires > 0 && expires - nowSec < 60) {
    await authService.refreshEatzyToken();
  }

  return localStorage.getItem("eatzyUserToken");
}
